/**
 * State Timeline constants — colors keyed by the actual eventName from the API.
 */

import { CHART_PALETTE } from "../../constants/chartPalette";

export const EVENT_COLORS = {
  "Charging Started": CHART_PALETTE.blue,
  "EV Plugged In": CHART_PALETTE.green,
  "EV Plugged Out": CHART_PALETTE.red,
  "Charging Stopped": CHART_PALETTE.amber,
  "Fault Detected": CHART_PALETTE.red,
  "Fault Cleared": CHART_PALETTE.cyan,
};

export const DEFAULT_SEGMENT_COLOR = CHART_PALETTE.slate;

export const MARGIN = { top: 10, right: 20, bottom: 30, left: 20 };

export const TIMELINE_BAR_HEIGHT = 36;
export const TIMELINE_BAR_RADIUS = 6;

export const TICK_COUNT = 6;
export const LABEL_CHAR_WIDTH = 7;
export const ABBREV_MIN_WIDTH = 30;
export const X_AXIS_GAP = 6;
export const X_AXIS_EXTRA_HEIGHT = 20;
export const DAY_MS = 86400000;
export const NOW_INDICATOR_THRESHOLD_MS = 60000;
